export default "__VITE_ASSET__CL84YEfF__"